import { useEffect } from "react";

const POSTHOG_API_KEY = "phc_yJW1VjHGGwmCbbrtczfqqNxgBDbhlhOWcdzcIJEOTFE";
const POSTHOG_HOST = "https://us.i.posthog.com";
const POSTHOG_SCRIPT_SRC = "https://us-assets.i.posthog.com/static/array.js";

const usePosthogAnalytics = (enabled) => {
  useEffect(() => {
    if (typeof window === "undefined") {
      return undefined;
    }

    const isReactSnap = typeof navigator !== "undefined" && navigator.userAgent === "ReactSnap";
    if (isReactSnap) {
      window.posthog = null;
      return undefined;
    }

    if (!enabled) {
      if (window.posthog?.opt_out_capturing) {
        window.posthog.opt_out_capturing();
      }
      return undefined;
    }

    if (!window.posthog) {
      window.posthog = [];
    }

    const initializePosthog = () => {
      if (!window.posthog || typeof window.posthog.init !== "function") {
        return;
      }

      if (window.__posthogInitialized) {
        window.posthog.opt_in_capturing?.();
        return;
      }

      window.posthog.init(POSTHOG_API_KEY, {
        api_host: POSTHOG_HOST,
        person_profiles: "identified_only",
      });
      window.__posthogInitialized = true;
    };

    if (window.__posthogInitialized) {
      initializePosthog();
      return undefined;
    }

    const existingScript = document.querySelector('script[data-posthog="true"]');
    if (existingScript) {
      if (typeof window.posthog?.init === "function") {
        initializePosthog();
      } else {
        existingScript.addEventListener("load", initializePosthog, { once: true });
      }
      return undefined;
    }

    const script = document.createElement("script");
    script.src = POSTHOG_SCRIPT_SRC;
    script.async = true;
    script.crossOrigin = "anonymous";
    script.type = "text/javascript";
    script.setAttribute("data-posthog", "true");
    script.addEventListener("load", initializePosthog, { once: true });
    script.addEventListener("error", () => {
      console.warn("[CookieConsent] Failed to load PostHog analytics.");
    });
    document.body.appendChild(script);

    return () => {
      script.removeEventListener("load", initializePosthog);
    };
  }, [enabled]);
};

export default usePosthogAnalytics;
